import { render, staticRenderFns } from "./salesProductChart.vue?vue&type=template&id=827d5fba&"
import script from "./salesProductChart.vue?vue&type=script&lang=js&"
export * from "./salesProductChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports